export default "__VITE_ASSET__DppinyCp__"